import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderCell = (column, colIndex, { sortElement, filterElement }) => {
    return (_jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: '8px' } }, { children: [_jsxs("div", { children: [sortElement, column.text] }), filterElement] })));
};
